/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDataCollectionsOrganizer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13 7H6V5h7zm5 0h-3V5h3z" />
        <path d="M22 2H2v20h20zM4 8V4h16v4zm12 4v-2h4v2zm0 4v-2h4v2zm0 4v-2h4v2zm-2-2v2h-4v-2zm-6 0v2H4v-2zm0-2H4v-2h4zm0-4H4v-2h4zm2 0v-2h4v2zm0 2h4v2h-4z" />
      </g>
    </g>
  </Icon>
);
export { SvgDataCollectionsOrganizer as DataCollectionsOrganizer };
